export default {"src":"/_next/static/media/0x5aea5775959fbc2557cc8789bc1bf90a239d9a91.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};